// login page strings. Keys are read as $t('login.<key>').
export default {
  en: {
    pageTitle: 'Login',
    brandSub: 'CS Console',
    title: 'Sign in',
    lead: 'Staff access only. Accounts are created by an administrator.',
    username: 'Username',
    usernamePlaceholder: 'username',
    password: 'Password',
    passwordPlaceholder: 'Password',
    submit: 'Sign in',
    fillBoth: 'Enter your username and password.',
    wrongPassword: 'Wrong username or password.',
    noServer: 'Cannot reach the server. Check the connection and try again.',
    failed: 'Sign-in failed. Try again.',
  },
  vi: {
    pageTitle: 'Đăng nhập',
    brandSub: 'CS Console',
    title: 'Đăng nhập',
    lead: 'Chỉ dành cho nhân viên. Tài khoản do quản trị viên tạo.',
    username: 'Tên đăng nhập',
    usernamePlaceholder: 'tên đăng nhập',
    password: 'Mật khẩu',
    passwordPlaceholder: 'Mật khẩu',
    submit: 'Đăng nhập',
    fillBoth: 'Nhập tên đăng nhập và mật khẩu.',
    wrongPassword: 'Sai tên đăng nhập hoặc mật khẩu.',
    noServer: 'Không kết nối được máy chủ. Kiểm tra mạng rồi thử lại.',
    failed: 'Đăng nhập không được. Thử lại.',
  },
}
